import { render, staticRenderFns } from "./MoreButton.vue?vue&type=template&id=7cf91f36&scoped=true&"
import script from "./MoreButton.vue?vue&type=script&lang=ts&"
export * from "./MoreButton.vue?vue&type=script&lang=ts&"
import style0 from "./MoreButton.vue?vue&type=style&index=0&id=7cf91f36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf91f36",
  null
  
)

export default component.exports